import { Inject, Injectable, Optional } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, of, ReplaySubject, Subject } from "rxjs";
import { IssueOverviewModel, PaginationResponse } from "src/app/classes";
import { DoubletSuggestion } from "../../shared/classes";
import { IDoubletProviderService } from "../../shared/interfaces";
import { Issue } from "../classes";
import { IIssueProviderService, IIssueTypeProviderService } from "../interfaces";
import { IssueService } from "./issue.service";

@Injectable()
export class CreateIssueService implements IDoubletProviderService, IIssueProviderService, IIssueTypeProviderService {

    issue$ = of(null);
    issueId$ = of(null);
    issueState$ = of(null);

    private _issueTypeSub = new BehaviorSubject<number>(null);

    private _checkerVisible = new BehaviorSubject<boolean>(true);
    checkerVisible$ = this._checkerVisible.asObservable();

    private _doubletClicked = new Subject<DoubletSuggestion>();
    doubletClicked$ = this._doubletClicked.asObservable();

    private _doublets = new ReplaySubject<PaginationResponse<DoubletSuggestion[]>>(1);
    doublets$ = this._doublets.asObservable();

    constructor(
        @Optional() @Inject('createIssueType') private _issueType: number, 
        private _issueService: IssueService,
        private _router: Router
    ) {
        this._issueTypeSub.next(this._issueType);
    }

    doubletClick = (doublet: DoubletSuggestion) => {
        this._doubletClicked.next(doublet);
        this._router.navigate(['/issue-details', doublet.identifier]);
    }

    getCurrentIssueType(){
        return this._issueTypeSub.asObservable();
    }

    setSearchFilter(){
        throw new Error("not implemented");
    }

    setSearchString = (term: string) => this._issueService.searchIssuesByString(term, { 'pageNumber': 1, 'pageSize': 50 }).subscribe((x => {
        var result = {
            totalItems: x.totalItems,
            content: x.content.map((y: IssueOverviewModel) => {
                return {
                    title: [y.issuenumber, y.issuetitle].filter(z => z ? true : false).join(' '),
                    subTitles: [],
                    identifier: y.issueid
                } as DoubletSuggestion
            })
        } as PaginationResponse<DoubletSuggestion[]>;
        this._doublets.next(result);
    }));

    setDoubletCheckerVisible = (value: boolean) => this._checkerVisible.next(value);

    updateIssue(issue: Issue): void {
        throw new Error("Method not implemented.");
    }
}